export default "/images/actorStockImg.svg?9b2137d6207ccb66a9a5d2f898f681b5";